import { render, staticRenderFns } from "./searchCenter.vue?vue&type=template&id=20fdcac5&scoped=true&"
import script from "./searchCenter.vue?vue&type=script&lang=js&"
export * from "./searchCenter.vue?vue&type=script&lang=js&"
import style0 from "./searchCenter.vue?vue&type=style&index=0&id=20fdcac5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fdcac5",
  null
  
)

export default component.exports